"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const ShakaRobustness = {
  MANIFEST_RETRY_ATTEMPTS: 2,
  MANIFEST_RETRY_INTERVAL: 1e3,
  // NOTE: Shaka's maxAttempts parameter includes the initial failed attempt, so if the desired goal is to perform 3 retries, this should be set to 4
  FATAL_ERROR_RECOVERY_ATTEMPTS: 4,
  FATAL_ERROR_RECOVERY_DELAY: 1e3,
  FATAL_ERROR_RECOVERY_BACKOFF: 2,
  // Jitters segment retry delays to avoid synchronized full-fleet retries after a CDN blip (AVIAJS-1775)
  FATAL_ERROR_RECOVERY_FUZZ: 0.5
};
const escapedHtml = /&(?:amp|lt|gt|quot|apos|nbsp|lrm|rlm|#[xX]?[0-9a-fA-F]+);/g;
function unescapeHtml(text) {
  if (text.indexOf("&") === -1) return text;
  return text.replace(escapedHtml, (match) => {
    switch (match) {
      case "&amp;":
        return "&";
      case "&lt;":
        return "<";
      case "&gt;":
        return ">";
      case "&quot;":
        return '"';
      case "&apos;":
        return "'";
      case "&nbsp;":
        return " ";
      case "&lrm;":
        return "‎";
      case "&rlm;":
        return "‏";
      default:
        if (match[1] === "#") {
          const code = match[2] === "x" || match[2] === "X" ? parseInt(match.slice(3), 16) : parseInt(match.slice(2), 10);
          return String.fromCodePoint(code);
        }
        return match;
    }
  });
}
function getElementsByName(node, name, found = []) {
  if (!node) return found;
  if (node.nodeName === name) found.push(node);
  if (node.childNodes) for (const child of node.childNodes) getElementsByName(child, name, found);
  return found;
}
const OPEN_BRACKET_CC = 60;
const CLOSE_BRACKET_CC = 62;
const MINUS_CC = 45;
const SLASH_CC = 47;
const QUESTION_CC = 63;
const EXCLAMATION_CC = 33;
const SINGLE_QUOTE_CC = 39;
const DOUBLE_QUOTE_CC = 34;
const OPEN_CORNER_BRACKET_CC = 91;
const CLOSE_CORNER_BRACKET_CC = 93;
const AMPERSAND_CC = 38;
const EQUALS_CC = 61;
const COLON_CC = 58;
const SPACE_CC = 32;
const TAB_CC = 9;
const CR_CC = 13;
const LF_CC = 10;
const UPPER_A_CC = 65;
const UPPER_Z_CC = 90;
const LOWER_A_CC = 97;
const LOWER_Z_CC = 122;
function syntaxError(input, pos, message) {
  const parsedText = input.substring(0, pos).split("\n");
  return /* @__PURE__ */ new Error(message + "\nLine: " + (parsedText.length - 1) + "\nColumn: " + (parsedText[parsedText.length - 1].length + 1) + "\nChar: " + (pos < input.length ? input[pos] : "end of input"));
}
function scan(input, start, keepWhitespace, builder, stack, names) {
  const createElement = builder.createElement;
  const appendChild = builder.appendChild;
  const appendText = builder.appendText;
  const appendCdata = builder.appendCdata;
  const appendComment = builder.appendComment;
  const appendDoctype = builder.appendDoctype;
  const length = input.length;
  let current = stack[stack.length - 1];
  let currentName = names[names.length - 1];
  let pos = start;
  while (pos < length) {
    let cc = input.charCodeAt(pos);
    if (cc !== OPEN_BRACKET_CC) {
      const textStart = pos;
      let hasAmpersand = false;
      let blank = true;
      do {
        if (cc !== SPACE_CC && cc !== LF_CC && cc !== CR_CC && cc !== TAB_CC) {
          blank = false;
          if (cc === AMPERSAND_CC) hasAmpersand = true;
        }
        cc = ++pos < length ? input.charCodeAt(pos) : 0;
      } while (pos < length && cc !== OPEN_BRACKET_CC);
      if (appendText !== void 0 && (keepWhitespace || !blank)) {
        let text = input.slice(textStart, pos);
        if (hasAmpersand) text = unescapeHtml(text);
        if (!keepWhitespace) text = text.trim();
        if (text.length > 0) appendText(current, text);
      }
      continue;
    }
    const next = pos + 1 < length ? input.charCodeAt(pos + 1) : 0;
    if (next === SLASH_CC) {
      const closeStart = pos + 2;
      const nameEnd = closeStart + currentName.length;
      const afterName = nameEnd < length ? input.charCodeAt(nameEnd) : 0;
      const closesTag = input.startsWith(currentName, closeStart) && (nameEnd >= length || currentName !== "" && (afterName === CLOSE_BRACKET_CC || afterName === SPACE_CC || afterName === TAB_CC || afterName === CR_CC || afterName === LF_CC));
      const end = input.indexOf(">", closeStart);
      pos = end === -1 ? length : end;
      if (!closesTag) throw syntaxError(input, pos, "Unexpected close tag");
      if (pos < length) pos++;
      if (stack.length > 1) {
        const child = current;
        stack.pop();
        names.pop();
        current = stack[stack.length - 1];
        currentName = names[names.length - 1];
        if (appendChild !== void 0) appendChild(current, child);
      }
      continue;
    }
    if (next === QUESTION_CC) {
      const end = input.indexOf(">", pos + 2);
      pos = end === -1 ? length : end + 1;
      continue;
    }
    if (next === EXCLAMATION_CC) {
      const third = pos + 2 < length ? input.charCodeAt(pos + 2) : 0;
      if (third === MINUS_CC) {
        const end = input.indexOf("-->", pos + 2);
        const stop = end === -1 ? length : end + 3;
        if (appendComment !== void 0) appendComment(current, input.slice(pos, stop));
        pos = stop;
        continue;
      }
      if (third === OPEN_CORNER_BRACKET_CC && pos + 8 < length && input.charCodeAt(pos + 8) === OPEN_CORNER_BRACKET_CC && input.startsWith("CDATA", pos + 3)) {
        const end = input.indexOf("]]>", pos + 9);
        if (appendCdata !== void 0) appendCdata(current, end === -1 ? input.slice(pos + 9) : input.slice(pos + 9, end));
        pos = end === -1 ? length : end + 3;
        continue;
      }
      const doctypeStart = pos + 1;
      let bracketed = false;
      pos += 2;
      while (pos < length) {
        cc = input.charCodeAt(pos);
        if (cc === CLOSE_BRACKET_CC && !bracketed) break;
        if (cc === OPEN_CORNER_BRACKET_CC) bracketed = true;
        else if (bracketed && cc === CLOSE_CORNER_BRACKET_CC) bracketed = false;
        pos++;
      }
      if (appendDoctype !== void 0) appendDoctype(current, input.slice(doctypeStart, pos));
      pos++;
      continue;
    }
    const nameStart = ++pos;
    let colon = -1;
    cc = pos < length ? input.charCodeAt(pos) : 0;
    while (pos < length && cc !== SPACE_CC && cc !== CLOSE_BRACKET_CC && cc !== SLASH_CC && cc !== EQUALS_CC && cc !== LF_CC && cc !== CR_CC && cc !== TAB_CC) {
      if (cc === COLON_CC && colon === -1) colon = pos;
      cc = ++pos < length ? input.charCodeAt(pos) : 0;
    }
    const name = input.slice(nameStart, pos);
    const attributes = {};
    while (pos < length && cc !== CLOSE_BRACKET_CC) {
      if (cc >= UPPER_A_CC && cc <= UPPER_Z_CC || cc >= LOWER_A_CC && cc <= LOWER_Z_CC) {
        const attributeStart = pos;
        cc = ++pos < length ? input.charCodeAt(pos) : 0;
        while (pos < length && cc !== SPACE_CC && cc !== CLOSE_BRACKET_CC && cc !== SLASH_CC && cc !== EQUALS_CC && cc !== LF_CC && cc !== CR_CC && cc !== TAB_CC) cc = ++pos < length ? input.charCodeAt(pos) : 0;
        const attributeName = input.slice(attributeStart, pos);
        if (cc !== EQUALS_CC) {
          while (cc === SPACE_CC || cc === TAB_CC || cc === CR_CC || cc === LF_CC) cc = ++pos < length ? input.charCodeAt(pos) : 0;
          if (cc !== EQUALS_CC) throw syntaxError(input, pos, 'Malformed attribute "' + attributeName + '": expected "=" after name');
        }
        cc = ++pos < length ? input.charCodeAt(pos) : 0;
        if (cc !== SINGLE_QUOTE_CC && cc !== DOUBLE_QUOTE_CC) {
          while (cc === SPACE_CC || cc === TAB_CC || cc === CR_CC || cc === LF_CC) cc = ++pos < length ? input.charCodeAt(pos) : 0;
          if (cc !== SINGLE_QUOTE_CC && cc !== DOUBLE_QUOTE_CC) throw syntaxError(input, pos, 'Malformed attribute "' + attributeName + '": expected quoted value after "="');
        }
        const quote = cc;
        const valueStart = ++pos;
        let hasAmpersand = false;
        cc = pos < length ? input.charCodeAt(pos) : 0;
        while (pos < length && cc !== quote) {
          if (cc === AMPERSAND_CC) hasAmpersand = true;
          cc = ++pos < length ? input.charCodeAt(pos) : 0;
        }
        if (pos >= length) throw new Error("Missing closing quote");
        const value = input.slice(valueStart, pos);
        attributes[attributeName] = hasAmpersand ? unescapeHtml(value) : value;
        cc = ++pos < length ? input.charCodeAt(pos) : 0;
        continue;
      }
      cc = ++pos < length ? input.charCodeAt(pos) : 0;
    }
    const selfClosing = input.charCodeAt(pos - 1) === SLASH_CC;
    pos++;
    const element = createElement(current, name, attributes, colon === -1 ? name : name.slice(colon - nameStart + 1), colon === -1 ? null : name.slice(0, colon - nameStart));
    if (selfClosing) {
      if (appendChild !== void 0) appendChild(current, element);
    } else {
      stack.push(element);
      names.push(name);
      current = element;
      currentName = name;
    }
  }
  while (stack.length > 1) {
    const child = current;
    stack.pop();
    names.pop();
    current = stack[stack.length - 1];
    if (appendChild !== void 0) appendChild(current, child);
  }
}
const HASH_CC = 35;
function parentElementOf(parent) {
  return parent.nodeName.charCodeAt(0) === HASH_CC ? null : parent;
}
function createTreeBuilder(keepComments, includeParentElement) {
  const createLeaf = includeParentElement ? (parent, nodeName, nodeValue) => ({
    nodeName,
    nodeValue,
    attributes: {},
    childNodes: [],
    parentElement: parentElementOf(parent)
  }) : (_parent, nodeName, nodeValue) => ({
    nodeName,
    nodeValue,
    attributes: {},
    childNodes: []
  });
  const appendLeaf = (parent, nodeName, nodeValue) => {
    parent.childNodes.push(createLeaf(parent, nodeName, nodeValue));
  };
  return {
    createDocument: includeParentElement ? () => ({
      nodeName: "#document",
      nodeValue: null,
      childNodes: [],
      attributes: {},
      parentElement: null
    }) : () => ({
      nodeName: "#document",
      nodeValue: null,
      childNodes: [],
      attributes: {}
    }),
    createElement: includeParentElement ? (parent, nodeName, attributes, localName, prefix) => ({
      nodeName,
      nodeValue: null,
      attributes,
      childNodes: [],
      prefix,
      localName,
      parentElement: parentElementOf(parent)
    }) : (_parent, nodeName, attributes, localName, prefix) => ({
      nodeName,
      nodeValue: null,
      attributes,
      childNodes: [],
      prefix,
      localName
    }),
    appendChild: (parent, child) => {
      parent.childNodes.push(child);
    },
    appendText: (parent, text) => appendLeaf(parent, "#text", text),
    appendCdata: (parent, text) => appendLeaf(parent, "#cdata", text),
    appendComment: keepComments ? (parent, text) => appendLeaf(parent, "#comment", text) : void 0,
    appendDoctype: (parent, text) => appendLeaf(parent, "#doctype", text)
  };
}
const TREE_BUILDERS = [
  /* @__PURE__ */ createTreeBuilder(false, false),
  /* @__PURE__ */ createTreeBuilder(true, false),
  /* @__PURE__ */ createTreeBuilder(false, true),
  /* @__PURE__ */ createTreeBuilder(true, true)
];
function parseXml(input, options = {}) {
  const builder = TREE_BUILDERS[(options.keepComments ? 1 : 0) | (options.includeParentElement ? 2 : 0)];
  const document = builder.createDocument();
  scan(input, options.pos || 0, !!options.keepWhitespace, builder, [document], [""]);
  return document;
}
const GOOGLE_DAI_SCHEME_ID_URI = "urn:google:dai:2018";
function getCueId(schemeIdUri) {
  return schemeIdUri === GOOGLE_DAI_SCHEME_ID_URI ? "google_dai" : schemeIdUri;
}
function getEarlyTimelineEvents(response) {
  let xml;
  try {
    xml = parseXml(response);
  } catch (e) {
    return null;
  }
  const mpd = findNodeByName(xml.childNodes, "MPD");
  const { attributes } = mpd;
  if (attributes.type === "static") {
    const p1 = findNodeByName(mpd.childNodes, "Period");
    if (p1) {
      const events = findNodeByName(p1.childNodes, "EventStream");
      return events ? parseEventStream(events) : null;
    }
    return null;
  }
  return null;
}
function parseEventStream(node) {
  const timescale = parseInt(node.attributes.timescale);
  const schemeIdUri = node.attributes.schemeIdUri;
  if (!timescale || isNaN(timescale) || !schemeIdUri) {
    this.logger.info("shaka adapter encountered invalid EventStream node.");
    return null;
  }
  return node.childNodes.filter((n) => {
    const t = parseInt(n.attributes.presentationTime) / timescale;
    return n.nodeName === "Event" && t < 1;
  }).map((n) => parseEvent(n, timescale, schemeIdUri));
}
function parseEvent(node, timescale, schemeIdUri) {
  const { duration, messageData, presentationTime } = node.attributes;
  const pts = parseInt(presentationTime) || 0;
  const data = messageData || "";
  const startTime = pts / timescale;
  return {
    id: getCueId(schemeIdUri),
    info: data,
    text: data,
    data,
    source: {},
    startTime,
    endTime: startTime + parseFloat(duration),
    schemeIdUri
  };
}
function findNodeByName(nodes, name) {
  return nodes.find((n) => n.nodeName === name);
}
function findDefaultAudioTrackSwitch(tracks, activeTrack) {
  var _a;
  if (!activeTrack || activeTrack.default) {
    return null;
  }
  return (_a = tracks.find((track) => track.default && track.language === activeTrack.language && track.type === activeTrack.type)) != null ? _a : null;
}
var PlayerHookType = /* @__PURE__ */ ((PlayerHookType2) => {
  PlayerHookType2["EVENT"] = "event";
  PlayerHookType2["AD_BREAK"] = "adbreak";
  PlayerHookType2["AD"] = "ad";
  PlayerHookType2["ATTACH_RESOURCE"] = "attachresource";
  PlayerHookType2["REQUEST"] = "request";
  PlayerHookType2["RESPONSE"] = "response";
  PlayerHookType2["MANIFEST_RESPONSE"] = "manifestresponse";
  PlayerHookType2["VIDEO_RESPONSE"] = "videoresponse";
  PlayerHookType2["AUDIO_RESPONSE"] = "audioresponse";
  PlayerHookType2["SEEK"] = "seek";
  return PlayerHookType2;
})(PlayerHookType || {});
var RequestObjectType = /* @__PURE__ */ ((RequestObjectType2) => {
  RequestObjectType2["MANIFEST"] = "manifest";
  RequestObjectType2["SEGMENT"] = "segment";
  RequestObjectType2["KEY"] = "key";
  RequestObjectType2["OTHER"] = "other";
  return RequestObjectType2;
})(RequestObjectType || {});
function getResponseHookType(objectType, streamType) {
  if (objectType === RequestObjectType.MANIFEST) {
    return PlayerHookType.MANIFEST_RESPONSE;
  }
  if (objectType !== RequestObjectType.SEGMENT) {
    return void 0;
  }
  switch (streamType) {
    case "video":
      return PlayerHookType.VIDEO_RESPONSE;
    case "audio":
      return PlayerHookType.AUDIO_RESPONSE;
    default:
      return void 0;
  }
}
function isFatalNetworkError(error, recoverableSeverity) {
  return (error == null ? void 0 : error.handled) !== true && (error == null ? void 0 : error.severity) !== recoverableSeverity;
}
function isOffline() {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}
function isVideoCdnSegment(objectType, streamType, contentTypeHeader) {
  if (objectType !== RequestObjectType.SEGMENT) {
    return false;
  }
  if (streamType) {
    return streamType === "video";
  }
  return /video/i.test(contentTypeHeader != null ? contentTypeHeader : "");
}
const MPD = "MPD";
const STATIC = "static";
const REPRESENTATION = "Representation";
const ADAPTATION_SET = "AdaptationSet";
const HEV = "hev";
const HVC = "hvc";
function serializeXml(xml) {
  const { nodeName, attributes, childNodes } = xml;
  if (nodeName === "#document") {
    return `<?xml version="1.0" encoding="UTF-8"?>${serializeXml(childNodes[0])}`;
  }
  if (nodeName === "#text") {
    return xml.nodeValue || "";
  }
  let result = `<${nodeName}`;
  if (attributes) {
    for (const key in attributes) {
      result += ` ${key}=${JSON.stringify(attributes[key])}`;
    }
  }
  let children = "";
  for (let i = 0, l = childNodes.length; i < l; i++) {
    children += serializeXml(childNodes[i]);
  }
  const close = !children ? " />" : `>${children}</${nodeName}>`;
  result += close;
  return result;
}
function normalizeHevcCodecs(xml) {
  const parsedXml = parseXml(xml);
  const mpdNodes = getElementsByName(parsedXml, MPD);
  const mpdNode = mpdNodes[0];
  const mpdType = mpdNode ? mpdNode.attributes.type : null;
  if (mpdType !== STATIC) {
    return xml;
  }
  const codecNodes = [...getElementsByName(parsedXml, REPRESENTATION), ...getElementsByName(parsedXml, ADAPTATION_SET)];
  codecNodes.forEach((node) => {
    const codec = node.attributes.codecs;
    if (codec == null ? void 0 : codec.includes(HEV)) {
      node.attributes.codecs = codec.replace(HEV, HVC);
    }
  });
  return serializeXml(parsedXml);
}
const DESCRIPTION_ROLES = /* @__PURE__ */ new Set(["description", "alternate"]);
function rolesToAudioTrackType(roles) {
  const normalizedRoles = roles != null ? roles : [];
  const isDescription = normalizedRoles.some((role) => DESCRIPTION_ROLES.has(role.trim()));
  return isDescription ? "description" : "main";
}
const SHAKA = "shaka";
const DEFAULT_SAFE_MARGIN = 2;
const DEFAULT_SHAKA_VERSION = "4.16.24";
const SHAKA_LIB = "aviaShakaLib";
const POLYFILLS_INSTALLED = "aviaShakaPolyfillsInstalled";
function isShakaSupported(context) {
  const { avia } = context;
  const { MimeType, PlaybackAdapterBase } = avia;
  return PlaybackAdapterBase.canPlay(context, [MimeType.DASH]);
}
function createShakaAdapter(context, options) {
  return __async(this, null, function* () {
    var _a;
    const { avia, resource, system, textTrackSettings, playerOptions } = context;
    const { playback } = resource;
    const { startTime } = playback;
    const { DrmType, ErrorCode, LogLevel, MimeType, PlaybackAdapterBase, PlayerError, Util } = avia;
    const debug = (options == null ? void 0 : options.debug) ? ".debug" : "";
    const libUrl = ((_a = options == null ? void 0 : options.dependencies) == null ? void 0 : _a.shaka) || `//cdn.jsdelivr.net/npm/shaka-player@${DEFAULT_SHAKA_VERSION}/dist/shaka-player.compiled${debug}.js`;
    const resident = system.global[SHAKA_LIB];
    if (resident && resident.namespace === system.global.shaka && resident.url !== libUrl) {
      delete system.global.shaka;
      delete system.global[SHAKA_LIB];
    }
    if (!system.global.shaka) {
      try {
        yield Util.loadScript(
          { url: libUrl },
          playerOptions,
          () => {
            return system.global.shaka;
          }
        );
        system.global[SHAKA_LIB] = { url: libUrl, namespace: system.global.shaka };
      } catch (error) {
        throw new PlayerError(ErrorCode.SHAKA_SDK_MISSING, "Could not load Shaka Player SDK", error);
      }
    }
    const {
      ErrorMessage,
      Header,
      PlayerHookType: PlayerHookType2,
      PerformanceMode,
      RequestObjectType: RequestObjectType2,
      TextTrackKind
    } = avia;
    const shaka2 = system.global.shaka;
    const isActive = (track) => track.active;
    const equal = (a, b) => JSON.stringify(a) === JSON.stringify(b);
    const isUnd = (track) => (track == null ? void 0 : track.language) === "und";
    class ShakaAdapter extends PlaybackAdapterBase {
      /**
       * ShakaAdapter
       */
      constructor(context2, options2 = {}) {
        var _a2, _b, _c;
        super(context2, options2, false);
        this.isHls = false;
        this.cachedCuepoints = null;
        this.cleanUpVtt = false;
        this.isLiveStream = false;
        this.renderTextTrackNatively = true;
        this.domTextTrack = null;
        this.audioSwitching = false;
        this.liveStartChecked = false;
        this.playerEventMap = {
          error: (event) => this.onError(event),
          streaming: () => this.onStreaming(),
          variantchanged: () => this.onVariantChanged(),
          adaptation: () => this.onVariantChanged(),
          manifestupdated: (event) => this.onManifestUpdated(event),
          emsg: (event) => this.onEmsg(event),
          metadata: (event) => this.onMetadata(event),
          trackschanged: Util.debounce(() => this.onTracksChanged(), 25),
          drmsessionupdate: () => this.onDrmSessionUpdate(),
          timelineregionenter: (event) => this.onTimelineRegionEnter(event)
        };
        this.responseHook = (context22) => {
          if (context22.metadata.objectType !== RequestObjectType2.MANIFEST || this.isLiveStream) {
            return;
          }
          try {
            context22.value.data = normalizeHevcCodecs(context22.value.data);
          } catch (error) {
            this.logger.warn("Unable to update HEVC codecs in manifest.");
          }
        };
        this.onRequest = (type, request) => {
          var _a3, _b2;
          const drm = this.context.resource.location.drm;
          if (type === shaka2.net.NetworkingEngine.RequestType.LICENSE) {
            if ((_a3 = drm.widevine) == null ? void 0 : _a3.header) {
              Object.assign(request.headers, drm.widevine.header);
            }
            if ((_b2 = drm.playready) == null ? void 0 : _b2.header) {
              Object.assign(request.headers, drm.playready.header);
            }
          }
        };
        this.onResponse = (type, response, requestContext) => {
          var _a3, _b2, _c2;
          const cdn = response.headers[Header.MULTI_CDN];
          if (cdn) {
            const streamType = (_c2 = (_a3 = requestContext == null ? void 0 : requestContext.stream) == null ? void 0 : _a3.type) != null ? _c2 : (_b2 = response.originalRequest) == null ? void 0 : _b2.contentType;
            const objectType = type === shaka2.net.NetworkingEngine.RequestType.SEGMENT ? RequestObjectType2.SEGMENT : RequestObjectType2.OTHER;
            const isVidSegment = isVideoCdnSegment(objectType, streamType, response.headers[Header.CONTENT_TYPE]);
            this.delegate.cdnChange(cdn, isVidSegment);
          }
        };
        this.onManifest = (type, response) => {
          const isManifest = type === shaka2.net.NetworkingEngine.RequestType.MANIFEST;
          if (isManifest) {
            const mimeType = Util.getResourceMimeType(resource);
            const isHls = response.uri.includes(".m3u8") || mimeType === avia.MimeType.HLS || mimeType === avia.MimeType.HLS_ALT;
            this.isHls = isHls;
            if (!isHls && !this.options.skipEventStreamParsing && (startTime === 0 || !Util.isValidPlayheadTime(startTime))) {
              const str = this.context.avia.Util.bufferToString(response.data);
              this.cachedCuepoints = getEarlyTimelineEvents(str);
            }
            this.player.getNetworkingEngine().unregisterResponseFilter(this.onManifest);
          }
        };
        let margin = (_a2 = options2.safeMargin) != null ? _a2 : DEFAULT_SAFE_MARGIN;
        if (!Number.isFinite(margin) || margin < 0) {
          margin = DEFAULT_SAFE_MARGIN;
        }
        this.safeMargin = margin;
        if (options2.debounceTracksChanged === false) {
          this.playerEventMap.trackschanged = () => {
            clearTimeout(this.tracksChangedTimeout);
            this.tracksChangedTimeout = setTimeout(() => this.onTracksChanged(), 25);
          };
        }
        this.logger.info(`Shaka Player version: ${shaka2.Player.version}`);
        if (typeof VTTCue === "undefined") {
          this.cleanUpVtt = true;
        }
        if (!system.global[POLYFILLS_INSTALLED]) {
          system.global[POLYFILLS_INSTALLED] = true;
          shaka2.polyfill.installAll();
        }
        const Level = (_b = shaka2.log) == null ? void 0 : _b.Level;
        if (options2.logLevel && Level) {
          let shakaLogLevel;
          switch (options2.logLevel) {
            case LogLevel.OFF:
              shakaLogLevel = Level.OFF;
              break;
            case LogLevel.ERROR:
              shakaLogLevel = Level.ERROR;
              break;
            case LogLevel.WARN:
              shakaLogLevel = Level.WARNING;
              break;
            case LogLevel.INFO:
              shakaLogLevel = Level.INFO;
              break;
            case LogLevel.DEBUG:
              shakaLogLevel = Level.DEBUG;
              break;
            case LogLevel.VERBOSE:
              shakaLogLevel = Level.V1;
              break;
          }
          shaka2.log.setLevel(shakaLogLevel);
        }
        this.player = new shaka2.Player();
        this.player.attach(this.video);
        const playerConfig = this.playerConfig = this.player.getConfiguration();
        this.addEvents(this.player, this.playerEventMap);
        let retry = this.playerConfig.streaming.retryParameters;
        retry.maxAttempts = ShakaRobustness.FATAL_ERROR_RECOVERY_ATTEMPTS;
        retry.baseDelay = ShakaRobustness.FATAL_ERROR_RECOVERY_DELAY;
        retry.backoffFactor = ShakaRobustness.FATAL_ERROR_RECOVERY_BACKOFF;
        retry.fuzzFactor = ShakaRobustness.FATAL_ERROR_RECOVERY_FUZZ;
        retry = this.playerConfig.manifest.retryParameters;
        retry.maxAttempts = ShakaRobustness.MANIFEST_RETRY_ATTEMPTS;
        retry.baseDelay = ShakaRobustness.MANIFEST_RETRY_INTERVAL;
        this.playerConfig.streaming.lowLatencyMode = false;
        const networkEngine = this.player.getNetworkingEngine();
        networkEngine.registerRequestFilter(this.onRequest);
        networkEngine.registerResponseFilter(this.onResponse);
        networkEngine.registerResponseFilter(this.onManifest);
        const { playready, widevine } = resource.location.drm;
        const { PLAYREADY, WIDEVINE } = DrmType;
        const configureDrm = (drm, dfltSystem) => {
          const { keySystem: system2 = dfltSystem } = drm;
          if (drm == null ? void 0 : drm.url) {
            playerConfig.drm.servers[system2] = drm.url;
            playerConfig.drm.advanced[system2] = {};
            if (drm.audioRobustness) {
              playerConfig.drm.advanced[system2].audioRobustness = drm.audioRobustness;
            }
            if (drm.videoRobustness) {
              playerConfig.drm.advanced[system2].videoRobustness = drm.videoRobustness;
            }
            playerConfig.drm.preferredKeySystems.push([system2, drm.priority]);
          }
        };
        configureDrm(widevine, WIDEVINE);
        configureDrm(playready, PLAYREADY);
        playerConfig.drm.preferredKeySystems = this.playerConfig.drm.preferredKeySystems.sort((a, b) => a[1] - b[1]).map((i) => i[0]);
        const abrConfig = playback.abr;
        const { restrictions, abr } = this.playerConfig;
        if (abrConfig.ignoreDevicePixelRatio === true) {
          abr.ignoreDevicePixelRatio = abrConfig.ignoreDevicePixelRatio;
        }
        if (abrConfig.minBitrate && !isNaN(abrConfig.minBitrate)) {
          this.minBitrate = abrConfig.minBitrate;
          restrictions.minBandwidth = abrConfig.minBitrate;
        }
        if (abrConfig.maxBitrate && !isNaN(abrConfig.maxBitrate)) {
          this.maxBitrate = abrConfig.maxBitrate;
          restrictions.maxBandwidth = abrConfig.maxBitrate;
        }
        if (!isNaN(abrConfig.startBitrate)) {
          abr.defaultBandwidthEstimate = abrConfig.startBitrate * 1.15;
        } else {
          abr.defaultBandwidthEstimate = abrConfig.throughputEstimate;
        }
        if (abrConfig.maxHeight && !isNaN(abrConfig.maxHeight)) {
          abr.restrictions.maxHeight = abrConfig.maxHeight;
        }
        abr.restrictToElementSize = abrConfig.capQualityToScreenSize;
        const settings = context2.performanceSettings;
        if (settings.forwardBufferLength != null) {
          playerConfig.streaming.bufferingGoal = settings.forwardBufferLength;
        }
        if (settings.backBufferLength != null) {
          playerConfig.streaming.bufferBehind = settings.backBufferLength;
        }
        if (settings.mode === PerformanceMode.LOW) ;
        this.renderTextTrackNatively = textTrackSettings.native;
        const enableAdvancedCodecs = playback.enableAdvancedCodecs;
        if (playerConfig.restrictions.maxChannelsCount) {
          playerConfig.restrictions.maxChannelsCount = enableAdvancedCodecs ? Infinity : 2;
        }
        playerConfig.preferredVideoCodecs = ["avc"];
        playerConfig.preferredAudioCodecs = ["mp4"];
        if (enableAdvancedCodecs) {
          playerConfig.preferredVideoCodecs = playback.preferredVideoCodecs;
          playerConfig.preferredAudioCodecs = playback.preferredAudioCodecs;
        }
        playerConfig.preferredTextLanguage = textTrackSettings.language;
        playerConfig.preferredAudioLanguage = playerOptions.audioLanguage;
        playerConfig.preferredVariantRole = playerOptions.audioRole;
        if ("preferSpatialAudio" in playerConfig) {
          playerConfig.preferSpatialAudio = playback.preferSpatialAudio || false;
          if (playerConfig.preferSpatialAudio) {
            playerConfig.preferredAudioChannelCount = 0;
          }
        }
        playerConfig.manifest.hls.useSafariBehaviorForLive = false;
        playerConfig.manifest.dash.disableXlinkProcessing = true;
        const { cmcd } = resource;
        if (cmcd.enabled) {
          playerConfig.cmcd = {
            enabled: true,
            contentId: cmcd.contentId || "",
            sessionId: cmcd.sessionId || "",
            useHeaders: cmcd.useHeaders
          };
        }
        if ((_c = shaka2.text) == null ? void 0 : _c.SimpleTextDisplayer) {
          playerConfig.textDisplayFactory = () => new shaka2.text.SimpleTextDisplayer(this.video, "Shaka Player TextTrack");
        }
        if (options2.flattenCues === true) {
          playerConfig.textDisplayFactory = () => {
            const textDisplayer = new shaka2.text.SimpleTextDisplayer(this.video, "Shaka Player TextTrack");
            const append = textDisplayer.append.bind(textDisplayer);
            const flatten = (cues) => cues.reduce((acc, cue) => {
              if (cue.payload) {
                acc.push(Object.assign({}, cue, { nestedCues: [] }));
              }
              if (cue.nestedCues.length) {
                acc = acc.concat(flatten(cue.nestedCues));
              }
              return acc;
            }, []);
            textDisplayer.append = (cues) => append(flatten(cues));
            return textDisplayer;
          };
        }
        Util.merge(
          playerConfig,
          options2.config
        );
        this.configure();
        const aes = context2.resource.location.drm.aes;
        const needsAes = !Util.isEmpty(aes) && aes.header && aes.provider;
        if (needsAes) {
          this.player.getNetworkingEngine().registerRequestFilter((type, request) => {
            const { RequestType: RequestType2 } = shaka2.net.NetworkingEngine;
            const url = request.uris[0];
            if (type === RequestType2.KEY) {
              url.includes(aes.provider) && Object.assign(request.headers, aes.header);
            }
          });
        }
        if (options2.normalizeHevcCodecs !== false && enableAdvancedCodecs && Util.getResourceMimeType(resource) === MimeType.DASH) {
          context2.player.registerHook(PlayerHookType2.RESPONSE, this.responseHook);
        }
        const { RequestType } = shaka2.net.NetworkingEngine;
        function getObjectType(type) {
          let objectType;
          switch (type) {
            case RequestType.MANIFEST:
              objectType = RequestObjectType2.MANIFEST;
              break;
            case RequestType.SEGMENT:
              objectType = RequestObjectType2.SEGMENT;
              break;
            case RequestType.LICENSE:
            case RequestType.SERVER_CERTIFICATE:
            case RequestType.KEY:
              objectType = RequestObjectType2.KEY;
              break;
            default:
              objectType = RequestObjectType2.OTHER;
          }
          return objectType;
        }
        this.player.getNetworkingEngine().registerRequestFilter((type, request) => {
          if (!this.delegate.hasHook(PlayerHookType2.REQUEST)) {
            return void 0;
          }
          const value = Util.createRequest(request.uris[0], request.headers);
          const metadata = { objectType: getObjectType(type) };
          return this.delegate.applyHook(PlayerHookType2.REQUEST, value, metadata).then((value2) => {
            request.uris[0] = value2.url;
            request.headers = value2.headers;
            request.allowCrossSiteCredentials = value2.credentials === "include";
          });
        });
        this.player.getNetworkingEngine().registerResponseFilter((type, response, requestContext) => {
          var _a3;
          const objectType = getObjectType(type);
          const hookType = getResponseHookType(objectType, (_a3 = requestContext == null ? void 0 : requestContext.stream) == null ? void 0 : _a3.type);
          if (!this.hasResponseHook(hookType)) {
            return void 0;
          }
          const isManifest = type === shaka2.net.NetworkingEngine.RequestType.MANIFEST;
          let { data } = response;
          if (isManifest) {
            data = this.context.avia.Util.bufferToString(data);
          }
          const metadata = { objectType };
          return this.applyResponseHooks({ url: response.uri, data, headers: response.headers }, metadata, hookType).then((value) => {
            if (!value) {
              this.logger.warn("Response hook cancelled; using the original response");
              return;
            }
            response.uri = value.url;
            response.data = isManifest && typeof TextEncoder !== "undefined" ? new TextEncoder().encode(value.data) : value.data;
          }).catch((e) => {
            this.logger.error(e);
            response.data = data;
          });
        });
      }
      destroy() {
        var _a2, _b;
        (_b = (_a2 = this.playerEventMap.trackschanged).cancel) == null ? void 0 : _b.call(_a2);
        this.removeEvents(this.player, this.playerEventMap);
        clearTimeout(this.textTimeout);
        clearTimeout(this.tracksChangedTimeout);
        this.context.player.removeHook(PlayerHookType2.RESPONSE, this.responseHook);
        return this.player.destroy().then(() => {
          this.player = null;
          this.playerConfig = null;
          this.domTextTrack = null;
          if (this.cleanUpVtt) {
            delete window.VTTCue;
          }
          return super.destroy();
        });
      }
      /**
       *
       */
      getId() {
        return SHAKA;
      }
      get info() {
        return {
          id: this.getId(),
          version: shaka2.Player.version
        };
      }
      /**
       *
       */
      load() {
        return super.load().then((metadata) => __async(this, null, function* () {
          var _a2;
          try {
            yield this.player.load(
              resource.location.mediaUrl,
              Util.isValidPlayheadTime(startTime) ? startTime : void 0,
              Util.getResourceMimeType(resource) || void 0
            );
            this.isLiveStream = this.player.isLive();
            this.manifestVariants = this.player.getVariantTracks();
            const textTrackUrl = resource.location.textTrackUrl;
            if (!Util.isEmpty(textTrackUrl)) {
              const mime = Util.getMimeType(textTrackUrl);
              yield this.player.addTextTrackAsync(textTrackUrl, "en", TextTrackKind.CAPTIONS, mime);
            }
            this.suppressErrors = false;
            metadata.fragment.mimeType = ((_a2 = this.getActiveVariantTrack()) == null ? void 0 : _a2.mimeType) || "";
            return metadata;
          } catch (error) {
            throw this.createPlayerError(error, true);
          }
        }));
      }
      /**
       *
       */
      resize() {
        const { abr } = this.playerConfig;
        if (abr.restrictToElementSize === this.qualityCappedToScreenSize) {
          return;
        }
        abr.restrictToElementSize = this.qualityCappedToScreenSize;
        this.configure();
      }
      /**
       *
       */
      suspend() {
        this.playerConfig.streaming.bufferingGoal = 1;
        this.playerConfig.streaming.rebufferingGoal = 1;
        this.configure();
      }
      /**
       *
       */
      resume() {
        this.playerConfig.streaming.bufferingGoal = 10;
        this.playerConfig.streaming.rebufferingGoal = 10;
        this.configure();
      }
      /**
       *
       */
      getIsLiveStream() {
        return this.isLiveStream;
      }
      /**
       *
       */
      clearText() {
        if (this.domTextTrack) {
          Util.clearCue(this.domTextTrack, this.video.currentTime);
        }
      }
      /**
       *
       */
      setMinBitrate(value) {
        super.setMinBitrate(value);
        if (isNaN(value)) {
          value = -Infinity;
        }
        this.playerConfig.restrictions.minBandwidth = value;
        this.configure();
      }
      /**
       *
       */
      setMaxBitrate(value) {
        super.setMaxBitrate(value);
        if (isNaN(value)) {
          value = Infinity;
        }
        const maxAudioBandwidth = this.manifestVariants.reduce((acc, variant) => Math.max(variant.audioBandwidth, acc), 0);
        this.playerConfig.restrictions.maxBandwidth = value + maxAudioBandwidth;
        this.configure();
      }
      /**
       *
       */
      setAutoQualitySwitching(value) {
        this.playerConfig.abr.enabled = value;
        this.configure();
      }
      /**
       *
       */
      setQuality(quality) {
        const track = this.player.getVariantTracks().find((track2) => track2.id === quality.index);
        if (!track) {
          this.logger.warn("Quality track not found, will not set.");
          return;
        }
        this.player.selectVariantTrack(track, true);
      }
      /**
       * Returns the list of audio renditions in the manifest. Prefers Shaka's
       * native 'getAudioTracks' API (v4.14+); falls back to filtering
       * variants on older versions. Results are normalized to the variant
       * shape (audioRoles, audioCodec, language) so callers don't branch.
       */
      getShakaAudioTracks() {
        if (typeof this.player.getAudioTracks === "function") {
          return this.player.getAudioTracks().map((t) => {
            var _a2;
            return __spreadProps(__spreadValues({}, t), {
              audioRoles: (_a2 = t.roles) != null ? _a2 : [],
              audioCodec: t.codecs || ""
            });
          });
        }
        const audioKey = (variant) => {
          if (variant.originalAudioId) {
            return variant.originalAudioId;
          }
          const language = this.resolveLanguage(variant);
          const roles = (variant.audioRoles || []).join(",");
          const label = variant.label || language;
          return `${language}|${roles}|${label}|${variant.spatialAudio}|${variant.audioCodec || ""}`;
        };
        const seen = /* @__PURE__ */ new Set();
        return this.manifestVariants.filter((variant) => {
          const key = audioKey(variant);
          if (seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        }).map((variant) => __spreadProps(__spreadValues({}, variant), {
          language: this.resolveLanguage(variant)
        }));
      }
      /**
       * Some pre 4.14 versions report 'und' for muxed HLS audio.
       * Recover from originalLanguage so tracks aren't misclassified
       * as ad-inserted 'und' tracks downstream.
       */
      resolveLanguage(track) {
        return track.language && track.language !== "und" ? track.language : track.originalLanguage || track.language;
      }
      /**
       *
       */
      findShakaTrack(audioTracks, track) {
        return audioTracks.find((t) => {
          const language = this.resolveLanguage(t);
          return language === track.language && t.audioCodec === track.codec && t.spatialAudio === track.spatialAudio && (t.label || language) === track.label && rolesToAudioTrackType(t.audioRoles) === track.type;
        });
      }
      /**
       *
       */
      setAudioTrack(track) {
        if (!track) {
          this.logger.info("Audio track is null, will not set.");
          return;
        }
        this.audioSwitching = true;
        const shakaAudioTrack = typeof this.player.getAudioTracks === "function" ? this.player.getAudioTracks().find((t) => {
          const language = this.resolveLanguage(t);
          return language === track.language && (t.label || language) === track.label && t.spatialAudio === track.spatialAudio && rolesToAudioTrackType(t.roles) === track.type;
        }) : null;
        if (shakaAudioTrack && typeof this.player.selectAudioTrack === "function") {
          this.player.selectAudioTrack(shakaAudioTrack);
          return;
        }
        const shakaTrack = this.findShakaTrack(this.manifestVariants, track);
        if (shakaTrack) {
          this.player.selectVariantTrack(shakaTrack, true, this.safeMargin);
          return;
        }
        this.audioSwitching = false;
        this.logger.warn("Unable to switch audio track: no matching Shaka track was found.");
      }
      /**
       *
       */
      setTextTrack(value) {
        var _a2;
        if (!value || value.id === ((_a2 = this.textTrack) == null ? void 0 : _a2.id)) {
          return;
        }
        this.textTrack = value;
        this.delegate.textTrackChange(value);
        this.updateTextTrack();
      }
      /**
       *
       */
      setTextTrackMode(mode) {
        this.updateTextTrack();
        this.delegate.textTrackDisplayModeChange(mode);
      }
      /**
       *
       */
      getMetrics() {
        const variant = this.getActiveVariantTrack();
        const stats = this.player.getStats();
        return {
          droppedVideoFrames: stats.droppedFrames,
          framerate: variant.frameRate || Number.NaN,
          bandwidth: stats.estimatedBandwidth
        };
      }
      /**
       *
       */
      getThumbnails(time) {
        return super.getThumbnails(time).then((thumbnails) => {
          if (this.getIsLiveStream()) {
            const { start, end } = this.player.seekRange();
            time = Util.mapToRange(time, 0, end - start, start, end);
          }
          return Promise.all(this.player.getImageTracks().map((track) => this.player.getThumbnails(track.id, time))).then((thumbs) => {
            thumbs.filter((thumb) => !!thumb).forEach((thumb) => {
              const { width, height, positionX, positionY, uris } = thumb;
              const url = uris[0];
              thumbnails.push({
                x: positionX,
                y: positionY,
                width,
                height,
                url
              });
            });
            return thumbnails;
          });
        });
      }
      /**
       *
       */
      getThroughput() {
        const { estimatedBandwidth } = this.player.getStats();
        return Number.isFinite(estimatedBandwidth) ? estimatedBandwidth : super.getThroughput();
      }
      /**
       *
       */
      getSeekable() {
        return this.player.seekRange();
      }
      /**
       *
       */
      getLiveStreamUtcStart() {
        const relativeMs = (this.getCurrentTime() - this.player.seekRange().start) * 1e3;
        const utc = this.getLiveStreamUtcTime();
        return Math.round(utc - relativeMs);
      }
      /**
       *
       */
      getLiveStreamUtcTime() {
        return this.player.getPlayheadTimeAsDate().getTime();
      }
      /**
       *
       */
      configure() {
        this.player.configure(this.playerConfig);
      }
      /**
       *
       */
      getActiveVariantTrack() {
        return this.player.getVariantTracks().find(isActive) || {};
      }
      /**
       *
       */
      getAudioTrackIndex() {
        const activeTrack = this.getActiveVariantTrack();
        const type = rolesToAudioTrackType(activeTrack.audioRoles);
        const language = this.resolveLanguage(activeTrack);
        const label = activeTrack.label || language;
        return this.audioTracks.findIndex((item) => item.language === language && item.type === type && item.spatialAudio === activeTrack.spatialAudio && item.label === label);
      }
      /**
       *
       */
      getAudioTrack() {
        const activeTrack = this.getActiveVariantTrack();
        const language = this.resolveLanguage(activeTrack);
        const label = activeTrack.label || language;
        return { language, type: rolesToAudioTrackType(activeTrack.audioRoles), spatialAudio: activeTrack.spatialAudio, label };
      }
      /**
       *
       */
      updateAudioTracks() {
        const audioTracks = this.getShakaAudioTracks();
        let tracks = audioTracks.map((track2, index) => {
          return {
            index,
            id: index.toString(),
            type: rolesToAudioTrackType(track2.audioRoles),
            codec: track2.audioCodec || "",
            language: track2.language,
            label: track2.label || track2.language,
            default: track2.primary,
            spatialAudio: track2.spatialAudio
          };
        });
        tracks = tracks.filter((track2) => !isUnd(track2));
        if (!equal(tracks, this.audioTracks)) {
          this.audioTracks = tracks;
          this.delegate.audioTracksChange(this.audioTracks);
        }
        let track = tracks[this.getAudioTrackIndex()];
        if (isUnd(track)) {
          track = tracks.find((t) => !isUnd(t)) || tracks[0];
        }
        if (!this.audioTrack && !this.audioSwitching && track) {
          const defaultTrack = findDefaultAudioTrackSwitch(tracks, track);
          if (defaultTrack) {
            this.setAudioTrack(defaultTrack);
            return;
          }
        }
        if (!equal(track, this.audioTrack)) {
          this.updateAudioTrack(track);
        }
      }
      /**
       *
       */
      updateAudioTrack(track) {
        this.audioTrack = track;
        this.delegate.audioTrackChange(track);
        this.updateTextTrack();
      }
      /**
       *
       */
      updateTextTrack() {
        var _a2;
        const id = parseInt((_a2 = this.textTrack) == null ? void 0 : _a2.id);
        const tracks = this.player.getTextTracks();
        const track = tracks.find((track2) => track2.id === id);
        const forced = tracks.find((track2) => {
          var _a3;
          return track2.forced && track2.language === ((_a3 = this.audioTrack) == null ? void 0 : _a3.language);
        });
        const selected = textTrackSettings.enabled ? track : forced;
        const visible = textTrackSettings.enabled ? !!track : !!forced;
        if (selected) {
          this.player.selectTextTrack(selected);
        }
        this.player.setTextTrackVisibility(visible);
        if (!this.renderTextTrackNatively && this.domTextTrack) {
          this.playerConfig.streaming.alwaysStreamText = visible;
          this.configure();
          this.textTimeout = setTimeout(() => this.domTextTrack.mode = "hidden", 0);
        }
      }
      /**
       *
       */
      updateTextTracks() {
        const textTracks = this.player.getTextTracks().filter((track) => !track.forced);
        const tracks = textTracks.map((track) => {
          const kind = /subtitle/.test(track.kind) ? TextTrackKind.SUBTITLES : track.kind;
          return {
            id: track.id.toString(),
            language: track.language,
            kind,
            label: track.label || track.language
          };
        });
        if (!equal(tracks, this.textTracks)) {
          this.textTracks = tracks;
          this.delegate.textTracksChange(this.textTracks);
        }
        if (!this.domTextTrack) {
          this.domTextTrack = Array.from(this.video.textTracks).find((textTrack2) => textTrack2.label === "Shaka Player TextTrack");
          if (this.domTextTrack) {
            this.listenToTextTracks(true);
          }
        }
        const textTrack = textTracks.find(isActive);
        const id = textTrack == null ? void 0 : textTrack.id.toString();
        if (!this.textTrack || this.textTrack.id !== id) {
          let track = this.textTracks.find((track2) => track2.id === id);
          if (!track) {
            track = Util.findDefaultTrack(this.textTracks, textTrackSettings.language);
          }
          this.setTextTrack(track);
          return;
        }
        this.player.setTextTrackVisibility(textTrackSettings.enabled);
      }
      updateQualityVariant() {
        if (!this.qualities) {
          return;
        }
        const variant = this.getActiveVariantTrack();
        if (!variant) {
          return;
        }
        const id = variant.id;
        const quality = this.qualities.find((quality2) => quality2.index === id);
        if (quality) {
          this.updateQuality(quality);
        }
      }
      normalizeQuality(track) {
        const { id, bandwidth, width, height, codecs, frameRate } = track;
        return {
          index: id,
          bitrate: bandwidth,
          codec: codecs,
          enabled: true,
          category: [],
          frameRate,
          width,
          height
        };
      }
      /**
       *
       */
      createQualities() {
        if (!this.manifestVariants) {
          return [];
        }
        const audio = this.getAudioTrack();
        const matchesAudio = (track) => {
          const language = this.resolveLanguage(track);
          return rolesToAudioTrackType(track.audioRoles) === audio.type && Util.compareLanguageTags(language, audio.language) && track.spatialAudio === audio.spatialAudio && (track.label || language) === audio.label;
        };
        const videoKey = (track) => `${track.bandwidth}|${track.width}x${track.height}|${track.videoCodec}`;
        const seen = /* @__PURE__ */ new Set();
        return this.manifestVariants.filter((track) => {
          const key = videoKey(track);
          if (!matchesAudio(track) || seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        }).map(this.normalizeQuality);
      }
      /**
       *
       */
      refreshQualities() {
        this.updateQualities(this.createQualities());
        if (isFinite(this.maxBitrate)) {
          this.setMaxBitrate(this.maxBitrate);
        }
      }
      /**
       *
       */
      createPlayerError(error, isLoadFailure = false) {
        var _a2, _b, _c;
        const Error2 = shaka2.util.Error;
        const Category = Error2.Category;
        const Code = Error2.Code;
        const toError = (code, message, cause, fatal = true, detail) => {
          for (const key in Code) {
            const value = Code[key];
            if (value === error.code) {
              message += ` : ${key} / ${value}`;
              break;
            }
          }
          return this.createError(code, message, cause, fatal, detail);
        };
        switch (error.category) {
          case Category.NETWORK: {
            const answered = error.code === Code.BAD_HTTP_STATUS;
            const exhausted = isLoadFailure || isFatalNetworkError(error, Error2.Severity.RECOVERABLE);
            const offline = exhausted && !answered && isOffline();
            const fatal = exhausted && !offline;
            const detail = {
              response: {
                status: answered ? (_a2 = error.data) == null ? void 0 : _a2[1] : null,
                url: (_c = (_b = error.data) == null ? void 0 : _b[0]) != null ? _c : null
              },
              offline
            };
            const message = fatal ? ErrorMessage.FATAL_PLAYBACK_NETWORK_ERROR : ErrorMessage.NONFATAL_PLAYBACK_NETWORK_ERROR;
            return toError(ErrorCode.SHAKA_NETWORK_ERROR, message, error, fatal, detail);
          }
          case Category.MANIFEST:
            return toError(ErrorCode.SHAKA_PARSE_ERROR, ErrorMessage.FATAL_PLAYBACK_MEDIA_ERROR, error);
          case Category.MEDIA:
            const code = error.code === Code.VIDEO_ERROR && error.data[0] === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED ? ErrorCode.SHAKA_SRC_NOT_SUPPORTED : ErrorCode.SHAKA_MEDIA_ERROR;
            return toError(code, ErrorMessage.FATAL_PLAYBACK_MEDIA_ERROR, error);
          case Category.DRM:
            return toError(ErrorCode.SHAKA_DRM_ERROR, ErrorMessage.FATAL_PLAYBACK_MEDIA_ERROR, error);
          default:
            return toError(ErrorCode.UNSPECIFIED_SHAKA_ERROR, ErrorMessage.UNSPECIFIED_ERROR, error, false);
        }
      }
      onCueChange(event) {
        const track = this.player.getTextTracks().find((track2) => track2.active);
        if (!track) {
          return;
        }
        super.onCueChange(event, track.forced);
      }
      /**
       *
       */
      onError(e) {
        const { code, message, cause, fatal, detail } = this.createPlayerError(e.detail);
        this.throwError(code, message, cause, fatal, detail);
      }
      /**
       * TEMPORARY (AVIAJS-1820) — delete this override when we move to Shaka 5.x.
       *
       * Shaka computes the correct live-edge start time, then discards it in
       * `VideoWrapper.setStartTime_` whenever the element's `currentTime` is
       * already non-zero, reading that as a user seek after `load()`. A DAI
       * multi-period timeline starts at a large offset, so `currentTime` is
       * non-zero as soon as MediaSource is set up and playback begins at the DVR
       * window start instead. Shaka 5.0.0 removed that branch.
       *
       * Checked on `playing` rather than after `load()`: by then the start
       * position is applied, the seek range is populated, and the player knows the
       * stream type, which `goLive()` requires. Scoped to live DASH, the only case
       * observed and where the large timeline offset comes from.
       */
      onPlaying() {
        return __async(this, null, function* () {
          yield __superGet(ShakaAdapter.prototype, this, "onPlaying").call(this);
          if (!this.player || !this.video || this.liveStartChecked || !this.isLiveStream || this.isHls || Util.isValidPlayheadTime(startTime)) {
            return;
          }
          this.liveStartChecked = true;
          const { start, end } = this.getSeekable();
          const offset = this.getLiveEdgeOffset();
          const position = this.getCurrentTime();
          const parkedAtWindowStart = position - start <= offset && end - position > offset * 3;
          this.logger.info(`live start check: position ${position.toFixed(2)} in [${start.toFixed(2)}, ${end.toFixed(2)}], parked=${parkedAtWindowStart}`);
          if (parkedAtWindowStart) {
            this.context.player.goLive().then(() => this.logger.info("live start corrected")).catch((error) => this.logger.warn(`live start correction failed: ${error}`));
          }
        });
      }
      /**
       *
       */
      onStreaming() {
        this.segmentDuration = this.player.getStats().maxSegmentDuration;
      }
      onManifestUpdated(event) {
        return __async(this, null, function* () {
          var _a2;
          if (event.isLive || this.isHls || ((_a2 = resource.overrides) == null ? void 0 : _a2.skipLiveToVodManifestUpdate)) {
            return;
          }
          const { relativeTime, relativeDuration } = this.liveStreamInfo;
          playback.startTime = relativeTime / relativeDuration * this.getSeekable().end;
          this.isLiveStream = false;
          yield this.load();
          this.video.play();
        });
      }
      /**
       *
       */
      onVariantChanged() {
        if (this.audioSwitching) {
          this.audioSwitching = false;
          const { language, type, spatialAudio, label } = this.getAudioTrack();
          const audioTrack = this.audioTracks.find((track) => track.language === language && track.type === type && track.spatialAudio === spatialAudio && track.label === label);
          this.updateAudioTrack(audioTrack);
          return;
        }
        if (this.qualities == null) {
          return;
        }
        this.refreshQualities();
        this.updateQualityVariant();
      }
      /**
       *
       */
      onTracksChanged() {
        if (!this.player || !this.manifestVariants) {
          return;
        }
        this.updateAudioTracks();
        this.updateTextTracks();
        this.refreshQualities();
        if (!this.quality) {
          this.updateQualityVariant();
        }
      }
      /**
       *
       */
      onDrmSessionUpdate() {
        this.delegate.drmKeySystemCreated(this.player.keySystem());
      }
      /**
       *
       */
      onEmsg(event) {
        const emsg = event.detail;
        const { schemeIdUri, messageData, startTime: startTime2, endTime, value } = emsg || {};
        const { emsgAltId3SchemeIdUris } = playerOptions.overrides || {};
        if (emsg.schemeIdUri === "https://aomedia.org/emsg/ID3" && !this.useId3TimingCompensation) {
          return;
        } else if (this.useId3TimingCompensation || (emsgAltId3SchemeIdUris == null ? void 0 : emsgAltId3SchemeIdUris.includes(schemeIdUri))) {
          const frames = avia.id3.getId3Frames(messageData);
          frames.forEach((frame) => {
            this.metadataSurface.addId3Metadata(frame.key, {
              id: event.id,
              startTime: startTime2,
              endTime: startTime2 + (emsg.duration || 0),
              source: emsg,
              data: frame.data,
              info: frame.info,
              text: frame.info
            });
          });
          return;
        }
        this.delegate.metadataCuepoint({
          id: getCueId(schemeIdUri),
          info: value,
          text: value,
          data: messageData,
          source: emsg,
          startTime: startTime2,
          endTime,
          schemeIdUri
        });
      }
      /**
       *
       */
      onMetadata(event) {
        if (this.useId3TimingCompensation && !this.isHls) {
          return;
        }
        const { payload } = event;
        const { description, data } = payload;
        this.metadataSurface.addId3Metadata(payload.key, {
          id: "",
          info: description,
          text: data,
          data,
          source: event,
          startTime: event.startTime,
          endTime: event.endTime
        });
      }
      /**
       *
       */
      onTimelineRegionEnter(event) {
        var _a2, _b;
        if (this.video.seeking) {
          return;
        }
        const info = event.detail;
        const { startTime: startTime2, endTime, schemeIdUri, value, eventNode, eventElement } = info;
        let messageData;
        if (eventNode) {
          messageData = (_a2 = eventNode.attributes) == null ? void 0 : _a2.messageData;
        } else if (eventElement == null ? void 0 : eventElement.getAttribute) {
          try {
            messageData = eventElement.getAttribute("messageData");
          } catch (e) {
            this.logger.warn("Unable to obtain messageData from TimelineRegionInfo.eventElement");
          }
        }
        const txt = value || messageData;
        const data = messageData;
        const id = getCueId(schemeIdUri);
        const isCached = (_b = this.cachedCuepoints) == null ? void 0 : _b.find((e) => {
          return e.id === id && e.startTime === startTime2 && e.endTime === endTime && e.data === data;
        });
        if (isCached) {
          return;
        }
        this.delegate.metadataCuepoint({
          id,
          info: txt,
          text: txt,
          data,
          source: info,
          startTime: startTime2,
          endTime,
          schemeIdUri
        });
      }
      // aviajs-1050: Pending a fix in shaka, avoid loss of default ad impression.
      onTimeUpdate() {
        var _a2;
        if ((_a2 = this.cachedCuepoints) == null ? void 0 : _a2.find((q) => !q.emitted)) {
          const t = this.video.currentTime;
          this.cachedCuepoints.forEach((q) => {
            if (!q.emitted && t >= q.startTime) {
              const out = __spreadValues({}, q);
              q.emitted = true;
              this.delegate.metadataCuepoint(out);
            }
          });
        }
        super.onTimeUpdate();
      }
    }
    return new ShakaAdapter(context, options);
  });
}
function createShakaPlugin(services, options) {
  const { avia, logger, player } = services;
  if (typeof TextDecoder === "undefined") {
    logger.warn("Polyfill warning: TextDecoder is not defined");
  }
  player.registerAdapter({
    id: SHAKA,
    role: [avia.AdapterRole.PLAYBACK],
    options,
    factory: createShakaAdapter,
    isSupported: isShakaSupported
  });
  return {
    getId() {
      return SHAKA;
    },
    destroy() {
    }
  };
}
function shaka(options = {}) {
  return {
    id: SHAKA,
    factory: createShakaPlugin,
    options
  };
}
const DASH = "dash";
function createDashPlugin(services, options = {}) {
  const createOptions = (id) => {
    var _a;
    const opts = (_a = options.adapter) == null ? void 0 : _a[id];
    const dependencies = options.dependencies || {};
    return Object.assign({ debug: options.debug }, opts, { dependencies });
  };
  const plugins = [
    createShakaPlugin(services, createOptions(SHAKA))
  ];
  return {
    getId() {
      return DASH;
    },
    destroy() {
      plugins.map((plugin2) => {
        var _a;
        return (_a = plugin2.destroy) == null ? void 0 : _a.call(plugin2);
      });
    }
  };
}
function dash(options = {}) {
  return {
    id: DASH,
    factory: createDashPlugin,
    options
  };
}
const ID = DASH;
const createPlugin = createDashPlugin;
const plugin = dash;
exports.DASH = DASH;
exports.ID = ID;
exports.SHAKA = SHAKA;
exports.createDashPlugin = createDashPlugin;
exports.createPlugin = createPlugin;
exports.createShakaAdapter = createShakaAdapter;
exports.createShakaPlugin = createShakaPlugin;
exports.dash = dash;
exports.plugin = plugin;
exports.shaka = shaka;
//# sourceMappingURL=avia.dash.cjs.map
